import React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

const CaretDown = () => <Icon iconName="CaretDown" />;

export default CaretDown;
